export default __webpack_public_path__ + "static/media/volcano.ef169e94.ogg";